"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COOKIES_TO_AMP_PROP = void 0;
exports.cleanEventData = cleanEventData;
exports.extractUTParameters = extractUTParameters;
exports.getPageViewedEventProperties = getPageViewedEventProperties;
exports.prepareEventProperties = prepareEventProperties;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// Query string parameters to track and their corresponding Amplitude property names
var UTM_TO_AMP_PROP = [['utm_adgroup', 'utmAdGroup'], ['utm_bu', 'utmBu'], ['utm_network', 'utmNetwork'], ['ut_source', 'upgradeTriggerSource'], ['ut_source2', 'upgradeTriggerSource2'], ['ut_source3', 'upgradeTriggerSource3'], ['program', 'campaignId']];

// Cookies to track and their corresponding Amplitude property names
var COOKIES_TO_AMP_PROP = exports.COOKIES_TO_AMP_PROP = [['ep201', 'userSMSessionId'], ['ep202', 'userSMPersistentId'], ['attr_multitouch', 'multiTouchCookieId']];

/**
 * Extracts certain UT parameters from the current URL and returns them
 * formatted for Amplitude event properties
 *
 * @returns A dictionary of the extracted parameters
 */
function extractUTParameters() {
  var retVal = {};

  // Extract ut params and add them to eventData
  var urlParams = new URL(window.location.href).searchParams;
  UTM_TO_AMP_PROP.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      queryStringParameter = _ref2[0],
      amplitudeProperty = _ref2[1];
    if (urlParams.has(queryStringParameter)) {
      retVal[amplitudeProperty] = urlParams.get(queryStringParameter);
    }
  });
  return retVal;
}

/**
 * Removes @sm/metrics specific properties from event data
 *
 * @param eventData The event properties dictionary
 * @returns A shallow copy of the event data provided with some keys removed
 */
function cleanEventData(eventData) {
  var retVal = _objectSpread({}, eventData);

  // remove values we don't want to pass along as event properties
  delete retVal.amplitudeEvent;
  delete retVal.amplitudeUserProperties;
  delete retVal.actionType;
  delete retVal.actionFlow;
  delete retVal.disableDA;
  return retVal;
}

/**
 * Returns a dictionary of page viewed event properties for page viewed events
 *
 * @param eventName The name of the event being sent
 * @param eventData
 * @returns An empty dict if not a page viewed event, otherwise properties for a page viewed event
 */
function getPageViewedEventProperties(eventName) {
  var retVal = {};

  // we're only in the business of page view events
  if (eventName.indexOf('page viewed') > -1) {
    retVal = _objectSpread({
      urlPath: window.location.pathname,
      hostName: window.location.hostname
    }, extractUTParameters());
  }
  return retVal;
}

/**
 * Cleans and decorates the event properties for a given event
 *
 * @param eventName The name of the event to be sent
 * @param eventData The provided properties of the event
 * @returns Prepped dictionary of event properties
 */
function prepareEventProperties(eventName, eventData) {
  var retVal = cleanEventData(eventData);
  retVal = _objectSpread(_objectSpread({}, getPageViewedEventProperties(eventName)), retVal);
  return retVal;
}
//# sourceMappingURL=common.js.map